import templateStr from 'text!./templates/damage-list.html';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        require: '^gwFnolPaVehicleCollision',
        scope: {},
        link: function link(scope, element, attrs, collisionVehiclesCtrl) {
            scope.damagedParts = collisionVehiclesCtrl.damagedParts;

            scope.offDamage = function (partID) {
                collisionVehiclesCtrl.removeSelectedPart(partID);
            };
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/directives/DamageList.js
// module id = 1587
// module chunks = 0